export default "__VITE_ASSET__40e3f7cb__"